module.exports = __webpack_public_path__ + "img/programme-2.238a4c83.png";